module.exports = __webpack_public_path__ + "static/media/orange_collaborative.bc776265.svg";